import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import useApi from "../Api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SideLabelInput from "../Components/SideLabelInput";
import Button from "../Components/Button";
import { forgotPassword } from "../Api/Password";

const AddUser = ({ handleShowForm, getUsers }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const api = useApi();
  const [user, setUser] = useState({
    email: "",
    first_name: "",
    last_name: "",
    role: "user",
  });

  const userRoles = [{label: "User", value: "user"}, {label: "Manager", value: "manager"}, {
    label: "Admin",
    value: "administrator"
  }]

  const handleSubmit = (event) => {
    setIsFetching(true);
    api
      .post("/users", {
        user: {
          ...user,
          artist_users_attributes: artistIdsToSave.map((artistId) => ({
            artist_id: artistId,
          })),
        },
      })
      .then((response) => {
        NotificationManager.success("User successfully added", "Success", 2000);
        handleShowForm();
        getUsers();
        return response.data;
      })
      .then(() => {
        forgotPassword(user.email);
      })
      .catch((error) => {
        setIsFetching(false);
        setErrorMessage(error.response.data);
      })
      .finally(() => {});
    event.preventDefault();
  };

  const handleChange = ({ target: { id, value } }) => {
    setUser({
      ...user,
      [id]: value,
    });
  };

  const handleRoleChange = (e) => {
    setUser({
      ...user,
      role: e.value,
    });
  };

  const [allArtists, setAllArtists] = useState([]);

  const artistOptions = allArtists.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

  const [artistIdsToSave, setArtistIdsToSave] = useState([]);

  const handleSelect = (e) => {
    let value = Array.from(e, (option) => option.value);
    setArtistIdsToSave(value);
  };

  useEffect(() => {
    api.get(`/artists`).then((r) => {
      setAllArtists(r.data);
    });
  }, [api]);

  return (
    <div className="-mt-20 side-modal">
      <div className="flex-col">
        <header className="py-6 px-4 text-lg mb-2 bg-blue-500 text-white">
          <button onClick={handleShowForm} className="float-right -mt-4">
            <FontAwesomeIcon icon={faTimes}></FontAwesomeIcon>
          </button>
          <div>New User</div>
          <div className="text-xs">
            You can modify this information later if needed
          </div>
        </header>
        <div className="mt-8 px-4 tracking-normal	font-medium">
          User Information
        </div>
        <hr className="my-3 mx-4"></hr>
        <form className="mx-4 text-sm" id="submit" onSubmit={handleSubmit}>
          <div className="my-5">
            <SideLabelInput
              id="email"
              type="email"
              label="Email"
              value={user.email}
              name="email"
              onChange={handleChange}
              disabled={isFetching}
              required
            />
            {errorMessage?.errors?.email && (
              <div className="text-red-500 pt-2">
                Email {errorMessage.errors.email}
              </div>
            )}
          </div>
          <div className="my-5">
            <SideLabelInput
              id="first_name"
              type="first_name"
              label="First Name"
              value={user.first_name}
              name="first_name"
              onChange={handleChange}
              disabled={isFetching}
            />
          </div>
          <div className="my-5">
            <SideLabelInput
              id="last_name"
              type="last_name"
              label="Last Name"
              value={user.last_name}
              name="last_name"
              onChange={handleChange}
              disabled={isFetching}
            />
          </div>
          <div className="my-5">
            <label>Role</label>
            <div>
              <Select
                className="text-xs font-light"
                value={userRoles.find((option) => option.value === user.role)}
                options={userRoles}
                onChange={handleRoleChange}
              />
            </div>
          </div>
          {user.role !== "administrator" && user.role !== "manager" && (
            <div>
              <div className="mt-8 mb-4">
                Select artists to be managed by this user
              </div>
              <Select isMulti options={artistOptions} onChange={handleSelect} />
            </div>
          )}
          <div className="flex justify-center mt-8">
            {errorMessage?.error && (
              <div className="text-red-500 pb-2">{errorMessage.error}</div>
            )}
          </div>
          <div className="flex justify-end my-4">
            <div className="flex-col">
              <div className="float-right">
                <Button
                  text={isFetching ? `Loading ${"\u00A0"}` : "Save"}
                  type="submit"
                  form="submit"
                  value="Submit"
                  disabled={isFetching}
                  inProgress={isFetching}
                  className="button float-right"
                ></Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
